export default "__VITE_PUBLIC_ASSET__439f4f75__"